import { useMutation } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

export function useGeneratePasswordResetToken() {
  return useMutation({
    mutationFn: ({ email, tenant }: { email: string; tenant: string }) =>
      UsersService.generatePasswordResetToken(email, tenant),
    // Reset tokens are credentials; discard the result when the dialog unmounts.
    gcTime: 0,
    retry: false,
  });
}
